import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { IGlobalState, IGlocalActions } from "../interfaces/globalState";
import {
  cardStateInitialState,
  errorInitialState,
  RequestStatus,
  themeFormattedInitialState,
} from "../constants";

export const useStore = create<
  IGlobalState & IGlocalActions,
  [["zustand/persist", Partial<IGlobalState>]]
>(
  persist(
    (set) => ({
      errorState: errorInitialState,
      setErrorState: (errorState) => {
        set(() => ({ errorState }));
      },

      cardState: cardStateInitialState,
      setCardState: (cardState) => {
        set(() => ({ cardState }));
      },

      cardList: [],
      setCardList: (cardList) => {
        set(() => ({ cardList }));
      },

      theme: themeFormattedInitialState,
      setTheme: (theme) => {
        set(() => ({ theme }));
      },

      userProfile: {
        data: null,
        status: RequestStatus.NOT_LOADED,
      },
      setUserProfile: (userProfile) => {
        set(() => ({ userProfile }));
      },

      amountState: {
        amount: "",
      },
      setAmountState: (amountState) => {
        set(() => ({ amountState }));
      },

      paymentState: {
        payment: null,
      },
      setPaymentState: (paymentState) => {
        set(() => ({ paymentState }));
      },

      transactions: [],
      setTransactions: (transactions) => {
        set(() => ({ transactions }));
      },

      operations: [],
      setOperations: (operations) => {
        set(() => ({ operations }));
      },
      updateOperationStatus: (operationId, status) => {
        set((state) => ({
          operations: state.operations.map((op) =>
            op.operationId === operationId ? { ...op, status } : op
          ),
        }));
      },
      updateOperationFields: (operationId, fields) => {
        set((state) => ({
          operations: state.operations.map((op) =>
            op.operationId === operationId ? { ...op, ...fields } : op
          ),
        }));
      },

      quoteState: null,
      setQuoteState: (quoteState) => {
        set(() => ({ quoteState }));
      },
      
      linkId: null,
      setLinkId: (linkId) => {
        set(() => ({ linkId }));
      },
      
      exchangeRate: null,
      setExchangerate: (exchangeRate) => {
        set(() => ({ exchangeRate }));
      },
      
      sentMoneyToast: {
        visible: false,
        type: undefined,
        message: null
      },
      setSentMoneyToast: (sentMoneyToast) => {
        set(() => ({ sentMoneyToast }));
      },

      phonePromptSkipped: false,
      setPhonePromptSkipped: (phonePromptSkipped) => {
        set(() => ({ phonePromptSkipped }));
      },

      retryAvailableAt: null,
      setRetryAvailableAt: (retryAvailableAt) => {
        set(() => ({ retryAvailableAt }));
      },
    }),
    {
      name: "globalState",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        userProfile: state.userProfile,
        quoteState: state.quoteState,
        // linkId: state.linkId,
      }),
    }
  )
);
